import { ColumnId } from '../model/column-id.model';
import { TableColumn } from '../model/performer-data-column.model';
import { TranslationKeyMap } from '../table.i18n';

export const tableColumns: TableColumn[] = [
    {
        id: ColumnId.PERFORMER,
        label: TranslationKeyMap._785_PERFORMER,
        classSuffix: 'performer',
    },
    {
        id: ColumnId.MI2_SCORE,
        label: TranslationKeyMap._9852_MI2_SCORE__,
        classSuffix: 'mi2-score',
    },
    {
        id: ColumnId.IMPROVEMENT_CATEGORY,
        label: TranslationKeyMap._9853_IMPROVEMENT_CATEGORY,
        classSuffix: 'improvement-category',
    },
    {
        id: ColumnId.OA_SCORE,
        label: TranslationKeyMap._9854_OA_SCORE,
        classSuffix: 'oa-score',
    },
    {
        id: ColumnId.MI2_PLUS_SCORE,
        label: TranslationKeyMap._9855_MI2___SCORE,
        classSuffix: 'mi2-plus-score',
    },
    {
        id: ColumnId.SCORECARD_POINTS,
        label: TranslationKeyMap._9856_SCORECARD_SCORE,
        classSuffix: 'scorecard-points',
    },
    {
        id: ColumnId.SCORECARD_PERFORMANCE_CLASS,
        label: TranslationKeyMap._9857_SCORECARD_CATEGORY,
        classSuffix: 'scorecard-performance-class',
    },
    {
        id: ColumnId.PREVIOUS_SCORECARD_POINTS,
        label: TranslationKeyMap._9856_SCORECARD_SCORE,
        classSuffix: 'previous-scorecard-points',
    },
    {
        id: ColumnId.PREVIOUS_SCORECARD_PERFORMANCE_CLASS,
        label: TranslationKeyMap._9857_SCORECARD_CATEGORY,
        classSuffix: 'previous-scorecard-performance-class',
    },
    {
        id: ColumnId.IMPROVEMENT_ACHIEVED,
        label: TranslationKeyMap._9858___CHANGED,
        classSuffix: 'improvement-achieved',
    },
];
